// 1. Définitions de toutes les valeurs possibles pour SchoolClass.
export type SchoolClassValue =
  | "terminale_A1"
  | "terminale_A2"
  | "terminale_B"
  | "terminale_C"
  | "terminale_D"
  | "terminale_G1"
  | "terminale_G2"
  | "terminale_G3"
  | "troisieme_mc"
  | "troisieme_ml";

// 2. Mappage de value => label
const MAP_VALUE_TO_LABEL: Record<SchoolClassValue, string> = {
  terminale_A1: "Terminale A1",
  terminale_A2: "Terminale A2",
  terminale_B: "Terminale B",
  terminale_C: "Terminale C",
  terminale_D: "Terminale D",
  terminale_G1: "Terminale G1",
  terminale_G2: "Terminale G2",
  terminale_G3: "Terminale G3",
  troisieme_mc: "Troisième MC",
  troisieme_ml: "Troisième ML",
};

const MAP_LOWERCASE_VALUE_TO_LABEL: Record<string, string> = Object.fromEntries(
  Object.entries(MAP_VALUE_TO_LABEL).map(([value, label]) => [
    value.toLowerCase(),
    label,
  ]),
);

// 3. Fonction qui retourne le label pour une valeur donnée
export function getSchoolClassLabel(value?: string | null): string {
  const cleanValue = value?.trim();
  if (!cleanValue) {
    return " ";
  }

  const label = MAP_LOWERCASE_VALUE_TO_LABEL[cleanValue.toLowerCase()];
  if (label) {
    return label;
  }

  // Valeur inconnue : on la met en forme plutôt que de l'afficher brute
  // ("seconde_c" => "Seconde C").
  if (!cleanValue.includes("_")) {
    return cleanValue;
  }
  const [level, ...serie] = cleanValue.split("_");
  return [
    level.charAt(0).toUpperCase() + level.slice(1).toLowerCase(),
    ...serie.map((part) => part.toUpperCase()),
  ].join(" ");
}

// 4. Remplace les valeurs de classe dans un texte construit par le serveur
// (ex : titre de conversation "Epreuve de Juin, terminale_C Lycée ...").
const SCHOOL_CLASS_IN_TEXT = new RegExp(
  `\\b(${Object.keys(MAP_VALUE_TO_LABEL).join("|")})\\b`,
  "gi",
);

export function formatSchoolClassInText(text?: string | null): string {
  if (!text) {
    return "";
  }

  return text.replace(SCHOOL_CLASS_IN_TEXT, (match) =>
    getSchoolClassLabel(match),
  );
}
